import React, { useEffect, useState } from 'react';
import { getAuth } from 'firebase/auth';
import { getFirestore, collection, query, onSnapshot, doc, updateDoc, deleteDoc } from 'firebase/firestore';
import { initializeApp } from 'firebase/app';

const firebaseConfig = {
  apiKey: "AIzaSyDJ_lusSO40qPa2pKdvwOOexRPU2p4Vsro",
  authDomain: "tradeahv2.firebaseapp.com",
  projectId: "tradeahv2",
  storageBucket: "tradeahv2.firebasestorage.app",
  messagingSenderId: "398274404066",
  appId: "1:398274404066:web:74be764b202f62b91f08bb"
};

initializeApp(firebaseConfig);
const auth = getAuth();
const db = getFirestore();

// خطط الاشتراك
const PLANS = [
  { id: 'basic', name: 'الأساسية', price: 30 },
  { id: 'premium', name: 'المميزة', price: 60 },
  { id: 'gold', name: 'الذهبية', price: 100 }
];

// أنواع الاشتراكات
const SUBSCRIPTION_TYPES = [
  { id: 'monthly', name: 'شهري' },
  { id: 'quarterly', name: 'ربع سنوي' },
  { id: 'annual', name: 'سنوي' }
];

export default function AdminClientsPage() {
  const [user, setUser] = useState(null);
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState('');
  const [editingClient, setEditingClient] = useState(null);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((currentUser) => {
      if (currentUser) {
        setUser(currentUser);
      } else {
        window.location.href = '/login';
      }
    });
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    if (!user) return;

    // جلب جميع العملاء
    const q = query(collection(db, 'users'));
    const unsubscribe = onSnapshot(q, (snapshot) => {
      const clientsList = snapshot.docs
        .map(doc => ({ id: doc.id, ...doc.data() }))
        .filter(client => client.role !== 'admin') // استثناء المديرين
        .sort((a, b) => (b.created_at?.seconds || 0) - (a.created_at?.seconds || 0));
      
      setClients(clientsList);
      setLoading(false);
    });

    return () => unsubscribe();
  }, [user]);

  // تعديل بيانات العميل
  const handleSaveEdit = async () => {
    if (!editingClient) return;
    
    try {
      // حساب تواريخ الاشتراك
      let startDate, endDate;
      if (editingClient.subscription.status === 'active') {
        startDate = new Date();
        const duration = editingClient.subscription.type === 'monthly' ? 30 :
                         editingClient.subscription.type === 'quarterly' ? 90 : 365;
        endDate = new Date(startDate);
        endDate.setDate(endDate.getDate() + duration);
      }
      
      const updateData = {
        first_name: editingClient.first_name,
        last_name: editingClient.last_name,
        email: editingClient.email,
        phone: editingClient.phone,
        gender: editingClient.gender,
        country: editingClient.country,
        subscribed_markets: editingClient.subscribed_markets,
        subscription_plan: editingClient.subscription_plan,
        trial_status: editingClient.trial_status,
        role: editingClient.role
      };
      
      // تحديث بيانات الاشتراك إذا كان نشطًا
      if (editingClient.subscription.status === 'active') {
        updateData.subscription = {
          start_date: startDate.toISOString(),
          end_date: endDate.toISOString(),
          status: 'active',
          type: editingClient.subscription.type
        };
      }
      
      await updateDoc(doc(db, 'users', editingClient.id), updateData);
      setMessage("✅ تم تحديث بيانات العميل بنجاح!");
      setEditingClient(null);
      setTimeout(() => setMessage(""), 3000);
      
    } catch (error) {
      console.error("Error updating client:", error);
      setMessage(`❌ خطأ: ${error.message}`);
    }
  };

  // حذف عميل
  const handleDelete = async (clientId, clientName) => {
    if (window.confirm(`هل أنت متأكد من حذف العميل: ${clientName}؟\nهذه العملية لا يمكن التراجع عنها!`)) {
      try {
        await deleteDoc(doc(db, 'users', clientId));
        setMessage("✅ تم حذف العميل بنجاح!");
        setTimeout(() => setMessage(""), 3000);
      } catch (error) {
        console.error("Error deleting client:", error);
        setMessage("❌ فشل حذف العميل.");
      }
    }
  };

  // تفعيل/إلغاء تفعيل الحساب
  const toggleActivation = async (clientId, currentStatus) => {
    try {
      const newStatus = currentStatus === 'active' ? 'inactive' : 'active';
      const updateData = { 
        trial_status: newStatus,
        'subscription.status': newStatus
      };
      
      await updateDoc(doc(db, 'users', clientId), updateData);
      setMessage(`✅ تم ${newStatus === 'active' ? 'تفعيل' : 'إلغاء تفعيل'} الحساب بنجاح!`);
      setTimeout(() => setMessage(""), 3000);
      
    } catch (error) {
      console.error("Error toggling activation:", error);
      setMessage("❌ فشل تغيير حالة التفعيل.");
    }
  };

  if (loading) {
    return <div style={{ padding: '20px' }}>Loading clients...</div>;
  }

  return (
    <div style={{ padding: '20px', maxWidth: '1200px', margin: '0 auto' }}>
      <h2 style={{ color: '#1e40af', textAlign: 'center', marginBottom: '24px' }}>
        إدارة العملاء
      </h2>
      
      {message && (
        <div style={{ 
          padding: '12px', 
          borderRadius: '8px', 
          backgroundColor: message.includes('✅') ? '#f0fdf4' : '#fef2f2',
          color: message.includes('✅') ? '#166534' : '#b91c1c',
          marginBottom: '20px',
          border: message.includes('✅') ? '1px solid #bbf7d0' : '1px solid #fecaca'
        }}>
          {message}
        </div>
      )}

      {/* نموذج تعديل العميل */}
      {editingClient && (
        <div style={{ 
          backgroundColor: 'white', 
          padding: '24px', 
          borderRadius: '16px',
          border: '1px solid #e2e8f0',
          marginBottom: '24px'
        }}>
          <h3 style={{ color: '#1e40af', marginBottom: '16px' }}>
            تعديل بيانات العميل: {editingClient.first_name} {editingClient.last_name}
          </h3>
          
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', marginBottom: '20px' }}>
            <div>
              <label style={{ display: 'block', marginBottom: '6px', fontWeight: '500' }}>
                الاسم الأول
              </label>
              <input
                type="text"
                value={editingClient.first_name}
                onChange={(e) => setEditingClient({ ...editingClient, first_name: e.target.value })}
                style={{
                  width: '100%',
                  padding: '10px',
                  border: '1px solid #ddd',
                  borderRadius: '6px'
                }}
              />
            </div>
            <div>
              <label style={{ display: 'block', marginBottom: '6px', fontWeight: '500' }}>
                الاسم الأخير
              </label>
              <input
                type="text"
                value={editingClient.last_name}
                onChange={(e) => setEditingClient({ ...editingClient, last_name: e.target.value })}
                style={{
                  width: '100%',
                  padding: '10px',
                  border: '1px solid #ddd',
                  borderRadius: '6px'
                }}
              />
            </div>
          </div>
          
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', marginBottom: '20px' }}>
            <div>
              <label style={{ display: 'block', marginBottom: '6px', fontWeight: '500' }}>
                البريد الإلكتروني
              </label>
              <input
                type="email"
                value={editingClient.email}
                onChange={(e) => setEditingClient({ ...editingClient, email: e.target.value })}
                style={{
                  width: '100%',
                  padding: '10px',
                  border: '1px solid #ddd',
                  borderRadius: '6px'
                }}
              />
            </div>
            <div>
              <label style={{ display: 'block', marginBottom: '6px', fontWeight: '500' }}>
                رقم التليفون
              </label>
              <input
                type="tel"
                value={editingClient.phone}
                onChange={(e) => setEditingClient({ ...editingClient, phone: e.target.value })}
                style={{
                  width: '100%',
                  padding: '10px',
                  border: '1px solid #ddd',
                  borderRadius: '6px'
                }}
              />
            </div>
          </div>
          
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '20px', marginBottom: '20px' }}>
            <div>
              <label style={{ display: 'block', marginBottom: '6px', fontWeight: '500' }}>
                الجنس
              </label>
              <select
                value={editingClient.gender}
                onChange={(e) => setEditingClient({ ...editingClient, gender: e.target.value })}
                style={{
                  width: '100%',
                  padding: '10px',
                  border: '1px solid #ddd',
                  borderRadius: '6px'
                }}
              >
                <option value="male">ذكر</option>
                <option value="female">أنثى</option>
              </select>
            </div>
            <div>
              <label style={{ display: 'block', marginBottom: '6px', fontWeight: '500' }}>
                الدولة
              </label>
              <select
                value={editingClient.country}
                onChange={(e) => setEditingClient({ ...editingClient, country: e.target.value })}
                style={{
                  width: '100%',
                  padding: '10px',
                  border: '1px solid #ddd',
                  borderRadius: '6px'
                }}
              >
                <option value="EG">مصر</option>
                <option value="SA">السعودية</option>
                <option value="AE">الإمارات</option>
                <option value="KW">الكويت</option>
                <option value="QA">قطر</option>
                <option value="US">الولايات المتحدة</option>
                <option value="OTHER">أخرى</option>
              </select>
            </div>
            <div>
              <label style={{ display: 'block', marginBottom: '6px', fontWeight: '500' }}>
                الدور
              </label>
              <select
                value={editingClient.role}
                onChange={(e) => setEditingClient({ ...editingClient, role: e.target.value })}
                style={{
                  width: '100%',
                  padding: '10px',
                  border: '1px solid #ddd',
                  borderRadius: '6px'
                }}
              >
                <option value="user">عميل</option>
                <option value="pending">قيد الانتظار</option>
                <option value="analyst">محلل</option>
              </select>
            </div>
          </div>
          
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', marginBottom: '20px' }}>
            <div>
              <label style={{ display: 'block', marginBottom: '6px', fontWeight: '500' }}>
                خطة الاشتراك
              </label>
              <select
                value={editingClient.subscription_plan || 'basic'}
                onChange={(e) => setEditingClient({ ...editingClient, subscription_plan: e.target.value })}
                style={{
                  width: '100%',
                  padding: '10px',
                  border: '1px solid #ddd',
                  borderRadius: '6px'
                }}
              >
                {PLANS.map(plan => (
                  <option key={plan.id} value={plan.id}>{plan.name}</option>
                ))}
              </select>
            </div>
            <div>
              <label style={{ display: 'block', marginBottom: '6px', fontWeight: '500' }}>
                نوع الاشتراك
              </label>
              <select
                value={editingClient.subscription?.type || 'monthly'}
                onChange={(e) => setEditingClient({ 
                  ...editingClient, 
                  subscription: { ...editingClient.subscription, type: e.target.value } 
                })}
                style={{
                  width: '100%',
                  padding: '10px',
                  border: '1px solid #ddd',
                  borderRadius: '6px'
                }}
              >
                {SUBSCRIPTION_TYPES.map(type => (
                  <option key={type.id} value={type.id}>{type.name}</option>
                ))}
              </select>
            </div>
          </div>
          
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', marginBottom: '20px' }}>
            <div>
              <label style={{ display: 'block', marginBottom: '6px', fontWeight: '500' }}>
                حالة الحساب
              </label>
              <select
                value={editingClient.trial_status || 'pending'}
                onChange={(e) => setEditingClient({ ...editingClient, trial_status: e.target.value })}
                style={{
                  width: '100%',
                  padding: '10px',
                  border: '1px solid #ddd',
                  borderRadius: '6px'
                }}
              >
                <option value="pending">قيد الانتظار</option>
                <option value="active">مفعل</option>
                <option value="rejected">مرفوض</option>
              </select>
            </div>
            <div>
              <label style={{ display: 'block', marginBottom: '6px', fontWeight: '500' }}>
                الأسواق
              </label>
              <div style={{ 
                border: '1px solid #ddd', 
                borderRadius: '6px',
                padding: '8px',
                maxHeight: '100px',
                overflowY: 'auto'
              }}>
                {['EGX', 'TADAWUL', 'ADX', 'DFM', 'BKP', 'QE', 'NASDAQ'].map(market => (
                  <label key={market} style={{ display: 'block', margin: '4px 0' }}>
                    <input
                      type="checkbox"
                      checked={editingClient.subscribed_markets?.includes(market)}
                      onChange={(e) => {
                        const markets = [...(editingClient.subscribed_markets || [])];
                        if (e.target.checked) {
                          if (!markets.includes(market)) markets.push(market);
                        } else {
                          const index = markets.indexOf(market);
                          if (index > -1) markets.splice(index, 1);
                        }
                        setEditingClient({ ...editingClient, subscribed_markets: markets });
                      }}
                      style={{ marginRight: '8px' }}
                    />
                    {market}
                  </label>
                ))}
              </div>
            </div>
          </div>
          
          <div style={{ display: 'flex', gap: '12px' }}>
            <button
              onClick={handleSaveEdit}
              style={{
                backgroundColor: '#1e40af',
                color: 'white',
                border: 'none',
                padding: '10px 20px',
                borderRadius: '6px',
                cursor: 'pointer'
              }}
            >
              حفظ التعديلات
            </button>
            <button
              onClick={() => setEditingClient(null)}
              style={{
                backgroundColor: '#64748b',
                color: 'white',
                border: 'none',
                padding: '10px 20px',
                borderRadius: '6px',
                cursor: 'pointer'
              }}
            >
              إلغاء
            </button>
          </div>
        </div>
      )}

      {/* جدول العملاء */}
      <div style={{ 
        backgroundColor: 'white', 
        borderRadius: '16px',
        boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
        overflow: 'hidden'
      }}>
        <div style={{ 
          padding: '16px 24px',
          borderBottom: '1px solid #e2e8f0',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <h3 style={{ margin: 0, color: '#1e40af', fontSize: '18px' }}>
            جميع العملاء ({clients.length})
          </h3>
        </div>
        
        {clients.length === 0 ? (
          <div style={{ padding: '40px', textAlign: 'center', color: '#64748b' }}>
            لا توجد عملاء
          </div>
        ) : (
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr style={{ backgroundColor: '#f8fafc' }}>
                  <th style={{ padding: '16px', textAlign: 'left', fontWeight: '600', color: '#1e293b' }}>العميل</th>
                  <th style={{ padding: '16px', textAlign: 'left', fontWeight: '600', color: '#1e293b' }}>البريد</th>
                  <th style={{ padding: '16px', textAlign: 'left', fontWeight: '600', color: '#1e293b' }}>التليفون</th>
                  <th style={{ padding: '16px', textAlign: 'left', fontWeight: '600', color: '#1e293b' }}>الخطة</th>
                  <th style={{ padding: '16px', textAlign: 'left', fontWeight: '600', color: '#1e293b' }}>الحالة</th>
                  <th style={{ padding: '16px', textAlign: 'left', fontWeight: '600', color: '#1e293b' }}>الإجراءات</th>
                </tr>
              </thead>
              <tbody>
                {clients.map(client => (
                  <tr key={client.id} style={{ 
                    borderBottom: '1px solid #f1f5f9',
                    '&:last-child': { borderBottom: 'none' }
                  }}>
                    <td style={{ padding: '16px' }}>
                      <div style={{ fontWeight: '600', color: '#1e293b' }}>
                        {client.first_name} {client.last_name}
                      </div>
                      <div style={{ fontSize: '14px', color: '#64748b', marginTop: '4px' }}>
                        {client.country} • {client.gender === 'male' ? 'ذكر' : 'أنثى'}
                      </div>
                    </td>
                    <td style={{ padding: '16px', color: '#1e40af' }}>
                      {client.email}
                    </td>
                    <td style={{ padding: '16px' }}>
                      {client.phone || 'غير متوفر'}
                    </td>
                    <td style={{ padding: '16px' }}>
                      <span style={{ 
                        backgroundColor: client.subscription_plan === 'gold' ? '#fef3c7' : 
                                       client.subscription_plan === 'premium' ? '#dbeafe' : '#dcfce7',
                        color: client.subscription_plan === 'gold' ? '#92400e' : 
                                client.subscription_plan === 'premium' ? '#1d4ed8' : '#065f46',
                        padding: '4px 12px',
                        borderRadius: '16px',
                        fontSize: '13px',
                        fontWeight: '600'
                      }}>
                        {PLANS.find(p => p.id === client.subscription_plan)?.name || 'غير محدد'}
                      </span>
                    </td>
                    <td style={{ padding: '16px' }}>
                      {client.trial_status === 'active' ? (
                        <span style={{ 
                          backgroundColor: '#dcfce7', 
                          color: '#166534', 
                          padding: '4px 12px', 
                          borderRadius: '16px',
                          fontSize: '13px',
                          fontWeight: '600'
                        }}>
                          مفعل
                        </span>
                      ) : client.trial_status === 'pending' ? (
                        <span style={{ 
                          backgroundColor: '#fef3c7', 
                          color: '#92400e', 
                          padding: '4px 12px', 
                          borderRadius: '16px',
                          fontSize: '13px',
                          fontWeight: '600'
                        }}>
                          قيد الانتظار
                        </span>
                      ) : (
                        <span style={{ 
                          backgroundColor: '#fee', 
                          color: '#c53030', 
                          padding: '4px 12px', 
                          borderRadius: '16px',
                          fontSize: '13px',
                          fontWeight: '600'
                        }}>
                          مرفوض
                        </span>
                      )}
                    </td>
                    <td style={{ padding: '16px' }}>
                      <div style={{ display: 'flex', gap: '8px' }}>
                        <button
                          onClick={() => setEditingClient(client)}
                          style={{
                            backgroundColor: '#1e40af',
                            color: 'white',
                            border: 'none',
                            padding: '6px 12px',
                            borderRadius: '4px',
                            fontSize: '13px',
                            cursor: 'pointer'
                          }}
                        >
                          تعديل
                        </button>
                        <button
                          onClick={() => toggleActivation(client.id, client.trial_status)}
                          style={{
                            backgroundColor: client.trial_status === 'active' ? '#dc2626' : '#10b981',
                            color: 'white',
                            border: 'none',
                            padding: '6px 12px',
                            borderRadius: '4px',
                            fontSize: '13px',
                            cursor: 'pointer'
                          }}
                        >
                          {client.trial_status === 'active' ? 'إلغاء' : 'تفعيل'}
                        </button>
                        <button
                          onClick={() => handleDelete(client.id, `${client.first_name} ${client.last_name}`)}
                          style={{
                            backgroundColor: '#dc2626',
                            color: 'white',
                            border: 'none',
                            padding: '6px 12px',
                            borderRadius: '4px',
                            fontSize: '13px',
                            cursor: 'pointer'
                          }}
                        >
                          حذف
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}